import { TFunction } from 'i18next'

export interface SportDetails {
    title: string
    description: string
    image: {
        path: string
        alt: string
        pathMobile: string
        altMobile: string
    }
}

export const getVolleyballDetails = (t: TFunction): SportDetails => ({
    title: t('modals.sports.volleyball.title'),
    description: t('modals.sports.volleyball.description'),
    image: {
        path: '/img/whatis-Volley.png',
        alt: t('common.alt.volleyball'),
        pathMobile: '/img/Volleyballcard.png',
        altMobile: t('common.alt.volleyball'),
    },
})

export const getFootballDetails = (t: TFunction): SportDetails => ({
    title: t('modals.sports.football.title'),
    description: t('modals.sports.football.description'),
    image: {
        path: '/img/whatis-Football.png',
        alt: t('common.alt.football'),
        pathMobile: '/img/Footballcard.png',
        altMobile: t('common.alt.football'),
    },
})
